import Svg, { SvgProps } from './Svg';

export default function StakingIcon({ ...props }: SvgProps) {
  return (
    <Svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M37.3205 30.0004C39.0759 26.9601 40 23.5113 40 20.0006C40 16.4899 39.0759 13.0411 37.3205 10.0008C35.5651 6.96047 33.0404 4.43575 30 2.68042C26.9596 0.925083 23.5107 0.000975034 20 0.000975352L20 10.0008C21.7554 10.0008 23.4798 10.4629 25 11.3405C26.5202 12.2182 27.7826 13.4805 28.6603 15.0007C29.5379 16.5209 30 18.2453 30 20.0006C30 21.756 29.5379 23.4804 28.6603 25.0005L37.3205 30.0004Z"
        fill="url(#paint0_radial_staking_1)"></path>
      <path
        d="M20 40.0003C23.5107 40.0003 26.9596 39.0761 30 37.3208L25 28.6607C23.4798 29.5384 21.7554 30.0004 20 30.0004L20 40.0003Z"
        fill="url(#paint1_radial_staking_2)"></path>
      <path
        d="M-1.42072e-06 19.9999C-1.26547e-06 22.6263 0.517314 25.2269 1.52241 27.6534C2.5275 30.0799 4.00069 32.2846 5.85786 34.1418C7.71504 35.9989 9.91982 37.4721 12.3463 38.4771C14.7728 39.4822 17.3736 39.9995 20 39.9995L20 29.9997C18.6868 29.9997 17.3864 29.741 16.1732 29.2385C14.9599 28.736 13.8575 27.9994 12.9289 27.0708C12.0003 26.1422 11.2637 25.0399 10.7612 23.8266C10.2587 22.6134 10 21.3131 10 19.9999L-1.42072e-06 19.9999Z"
        fill="url(#paint2_radial_staking_3)"></path>
      <path
        d="M2.67949 10.0001C0.924123 13.0404 -1.62825e-06 16.4892 -1.42072e-06 19.9999L10 19.9999C10 18.2445 10.4621 16.5201 11.3397 15L2.67949 10.0001Z"
        fill="url(#paint3_radial_staking_4)"></path>
      <path
        d="M2.67949 10.0001C0.924123 13.0404 -1.62825e-06 16.4892 -1.42072e-06 19.9999L10 19.9999C10 18.2445 10.4621 16.5201 11.3397 15L2.67949 10.0001Z"
        fill="url(#paint4_radial_staking_5)"></path>
      <path
        d="M20 0.000228344C16.4893 0.000228438 13.0404 0.924337 10 2.67967L15 11.3398C16.5202 10.4621 18.2446 10 20 10L20 0.000228344Z"
        fill="url(#paint5_linear_staking_6)"></path>
      <defs>
        <radialGradient
          id="paint0_radial_staking_1"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(18.6865 21.3948) rotate(-30.1237) scale(23.0268 21.5109)">
          <stop stopColor="#F2A4FF"></stop>
          <stop offset="1" stopColor="#6D28FF"></stop>
        </radialGradient>
        <radialGradient
          id="paint1_radial_staking_2"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(22.129 25.8207) rotate(77.8447) scale(16.3488 344.132)">
          <stop stopColor="#FFCD6B"></stop>
          <stop offset="1" stopColor="#EA5DD3"></stop>
        </radialGradient>
        <radialGradient
          id="paint2_radial_staking_3"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(20 19.9999) rotate(132.663) scale(25.0219 25.0219)">
          <stop stopColor="#00DDFB"></stop>
          <stop offset="1" stopColor="#0075FF"></stop>
        </radialGradient>
        <radialGradient
          id="paint3_radial_staking_4"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(20 19.9998) rotate(-15.0033) scale(21.3647 21.3644)">
          <stop stopColor="#F2A4FF"></stop>
          <stop offset="1" stopColor="#5200FF"></stop>
        </radialGradient>
        <radialGradient
          id="paint4_radial_staking_5"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(21.3135 18.6057) rotate(149.876) scale(23.0268 21.5109)">
          <stop stopColor="#F2A4FF"></stop>
          <stop offset="1" stopColor="#6D28FF"></stop>
        </radialGradient>
        <linearGradient
          id="paint5_linear_staking_6"
          x1="17.703"
          y1="13.2806"
          x2="16.2277"
          y2="-1.71814"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#FFD2B9"></stop>
          <stop offset="1" stopColor="#FF6D6D"></stop>
        </linearGradient>
      </defs>
    </Svg>
  );
}
